import { AUTH_TOKEN_SET, clearPipelineFilters, setGlobalConfig, setUserPermissions } from 'actions'
import { GlobalConfigType } from 'actions/global.config.type'
import { API_USER_PERMISSIONS } from 'config'
import { QueryClient } from 'react-query'
import { persistor, store } from 'reducers'
import Api from 'services/api'

import { setSessionSwitchInProgress } from './sessionSwitch'

type ImpersonationSessionResponse = {
  token: string
  user: Record<string, any>
  impersonatedBy?: string
  impersonatedByName?: string
}

/** Apply a new JWT (impersonation or return-to-self) without a full page reload. */
export async function applyImpersonationSession(
  dispatch: (action: any) => void,
  queryClient: QueryClient,
  response: ImpersonationSessionResponse,
) {
  setSessionSwitchInProgress(true)
  try {
    dispatch({
      type: AUTH_TOKEN_SET,
      token: response.token,
      user: response.user,
      requirePwChange: false,
      warningPwChange: false,
    })
    dispatch(clearPipelineFilters())
    await persistor.flush()

    const permissions = await Api.get(API_USER_PERMISSIONS)
    const role = {
      ...permissions,
      ...(response.impersonatedBy
        ? {
            impersonatedBy: response.impersonatedBy,
            impersonatedByName: response.impersonatedByName,
          }
        : {}),
    }

    dispatch(setUserPermissions(role))

    const pagePerms = (store.getState() as any).globalConfigReducer?.[GlobalConfigType.PagePermissions] || {}
    dispatch(
      setGlobalConfig(GlobalConfigType.PagePermissions, {
        ...pagePerms,
        userDenies: permissions.pagePermissionDenies || [],
      }),
    )

    queryClient.setQueryData('permissions', permissions)
    await queryClient.invalidateQueries({
      predicate: (query) => query.queryKey[0] !== 'permissions',
    })
  } finally {
    setSessionSwitchInProgress(false)
  }
}
